var _circle, _g, _path, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F605(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.526 26.854c-1.859-5.111-4.66-7.668-7.461-7.668s-5.602 2.557-7.46 7.668c-.184.516.774 1.443 1.254.939 1.802-1.902 3.957-2.658 6.207-2.658s4.405.756 6.207 2.658c.478.504 1.437-.424 1.253-.939zM47.396 26.854c-1.859-5.111-4.66-7.668-7.461-7.668s-5.602 2.557-7.461 7.668c-.184.516.775 1.443 1.254.939 1.803-1.902 3.957-2.658 6.207-2.658s4.404.756 6.207 2.658c.478.504 1.437-.424 1.254-.939z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M46.001 38.049c0-.803-.474-1.807-1.822-2.066-3.464-.663-8.582-1.342-15.179-1.342h-.001c-6.595 0-11.714.68-15.177 1.342-1.35.259-1.822 1.263-1.822 2.066 0 7.271 5.612 14.592 17 14.592 11.389 0 17.001-7.321 17.001-14.592z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M41.691 38.283c-2.195-.369-6.838-1.014-12.69-1.014-5.854 0-10.496.645-12.692 1.014-1.294.217-1.373.742-1.283 1.486.054.441.137.975.265 1.553.142.639.262.936 1.266.816 1.921-.229 22.968-.229 24.888 0 1.004.119 1.123-.178 1.266-.816.127-.578.211-1.111.265-1.553.088-.744.009-1.269-1.285-1.486z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#65B1EF",
    d: "M60 30.188c.001 7.173-9.749 7.175-9.749 0 0-5.239 4.875-10.353 4.875-10.353S60 24.95 60 30.188z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F605);
export default __webpack_public_path__ + "static/media/1f605.548eb74be76f1edcc9c7ae4b78c33a24.svg";
export { ForwardRef as ReactComponent };